// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdc {
  --cdc-accent: var(--cl-pine, var(--brand-primary, #0877bc));
  --cdc-line: var(--cl-line, var(--border-color, #e2e8f0));
  --cdc-muted: var(--cl-muted, var(--text-secondary, #64748b));
  display: grid;
  gap: 0.65rem;
}

.cdc__actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10.5rem, 1fr));
  gap: 0.5rem;
}

.cdc__action {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 3rem;
  padding: 0.6rem 0.9rem;
  border-radius: 12px;
  border: 1px dashed color-mix(in srgb, var(--cdc-accent) 45%, var(--cdc-line));
  background: color-mix(in srgb, var(--cdc-accent) 6%, transparent);
  color: var(--cdc-accent);
  font: 600 0.86rem/1.15 var(--cl-body, inherit);
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease;
}

.cdc__action--primary {
  border-style: solid;
  border-color: var(--cdc-accent);
  background: var(--cdc-accent);
  color: #fff;
}

.cdc__action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.cdc__action:active:not(:disabled) {
  transform: scale(0.98);
}

.cdc__hidden-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.cdc__pages {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(5.6rem, 1fr));
  gap: 0.55rem;
}

.cdc-page {
  position: relative;
  display: grid;
  gap: 0.25rem;
}

.cdc-page__preview {
  display: block;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid var(--cdc-line);
  background: color-mix(in srgb, var(--cdc-accent) 5%, var(--bg-color, #fff));
}

.cdc-page__preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cdc-page__doc {
  height: 100%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 0.3rem;
  padding: 0.4rem;
  color: var(--cdc-accent);
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  word-break: break-all;
}

.cdc-page__index {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--cdc-muted);
  text-align: center;
}

.cdc-page__remove {
  appearance: none;
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  width: 1.75rem;
  height: 1.75rem;
  display: grid;
  place-items: center;
  border-radius: 999px;
  border: 0;
  background: color-mix(in srgb, #0f172a 72%, transparent);
  color: #fff;
  cursor: pointer;
}

.cdc__empty,
.cdc__notice {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 400;
  color: var(--cdc-muted);
}

.cdc__notice {
  color: var(--cl-warn, #d97706);
}

/* Full-screen document camera (desktop / webcam). */
.cdc-camera {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: grid;
  grid-template-rows: 1fr auto;
  background: #05070b;
  color: #fff;
  font-family: var(--cl-body, system-ui, sans-serif);
}

.cdc-camera__stage {
  position: relative;
  min-height: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.cdc-camera__video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cdc-camera__frame {
  position: absolute;
  inset: 8% 12%;
  border: 2px solid color-mix(in srgb, #fff 70%, transparent);
  border-radius: 14px;
  box-shadow: 0 0 0 100vmax color-mix(in srgb, #000 35%, transparent);
  pointer-events: none;
}

.cdc-camera__flash {
  position: absolute;
  inset: 0;
  background: #fff;
  opacity: 0.7;
  pointer-events: none;
}

.cdc-camera__status {
  position: absolute;
  max-width: 26rem;
  margin: 0;
  padding: 0 1.5rem;
  text-align: center;
  font-size: 0.95rem;
  color: color-mix(in srgb, #fff 80%, transparent);
}

.cdc-camera__status--error {
  color: #fecaca;
}

.cdc-camera__bar {
  display: grid;
  gap: 0.75rem;
  padding: 0.9rem 1.25rem calc(1.1rem + env(safe-area-inset-bottom, 0px));
  background: #0b0f17;
}

.cdc-camera__hint {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: color-mix(in srgb, #fff 72%, transparent);
}

.cdc-camera__controls {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
}

.cdc-camera__btn {
  appearance: none;
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.75rem;
  padding: 0 1rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, #fff 25%, transparent);
  background: transparent;
  color: #fff;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.cdc-camera__btn--done {
  justify-self: end;
  background: #fff;
  color: #0b0f17;
  border-color: #fff;
}

.cdc-camera__shutter {
  appearance: none;
  width: 4.4rem;
  height: 4.4rem;
  padding: 0.3rem;
  border-radius: 999px;
  border: 3px solid #fff;
  background: transparent;
  cursor: pointer;
}

.cdc-camera__shutter span {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 999px;
  background: #fff;
  transition: transform 0.12s ease;
}

.cdc-camera__shutter:active:not(:disabled) span {
  transform: scale(0.88);
}

.cdc-camera__shutter:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/consent/ConsentDocumentCapture.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;EAC3D,wDAAwD;EACxD,4DAA4D;EAC5D,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,6EAA6E;EAC7E,iEAAiE;EACjE,wBAAwB;EACxB,8CAA8C;EAC9C,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,wDAAwD;EACxD,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,2DAA2D;EAC3D,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".cdc {\n  --cdc-accent: var(--cl-pine, var(--brand-primary, #0877bc));\n  --cdc-line: var(--cl-line, var(--border-color, #e2e8f0));\n  --cdc-muted: var(--cl-muted, var(--text-secondary, #64748b));\n  display: grid;\n  gap: 0.65rem;\n}\n\n.cdc__actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(10.5rem, 1fr));\n  gap: 0.5rem;\n}\n\n.cdc__action {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 3rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: 12px;\n  border: 1px dashed color-mix(in srgb, var(--cdc-accent) 45%, var(--cdc-line));\n  background: color-mix(in srgb, var(--cdc-accent) 6%, transparent);\n  color: var(--cdc-accent);\n  font: 600 0.86rem/1.15 var(--cl-body, inherit);\n  cursor: pointer;\n  transition: transform 0.18s ease, background 0.18s ease;\n}\n\n.cdc__action--primary {\n  border-style: solid;\n  border-color: var(--cdc-accent);\n  background: var(--cdc-accent);\n  color: #fff;\n}\n\n.cdc__action:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.cdc__action:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.cdc__hidden-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.cdc__pages {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(5.6rem, 1fr));\n  gap: 0.55rem;\n}\n\n.cdc-page {\n  position: relative;\n  display: grid;\n  gap: 0.25rem;\n}\n\n.cdc-page__preview {\n  display: block;\n  aspect-ratio: 3 / 4;\n  overflow: hidden;\n  border-radius: 10px;\n  border: 1px solid var(--cdc-line);\n  background: color-mix(in srgb, var(--cdc-accent) 5%, var(--bg-color, #fff));\n}\n\n.cdc-page__preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cdc-page__doc {\n  height: 100%;\n  display: grid;\n  place-content: center;\n  justify-items: center;\n  gap: 0.3rem;\n  padding: 0.4rem;\n  color: var(--cdc-accent);\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-align: center;\n  word-break: break-all;\n}\n\n.cdc-page__index {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--cdc-muted);\n  text-align: center;\n}\n\n.cdc-page__remove {\n  appearance: none;\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  border: 0;\n  background: color-mix(in srgb, #0f172a 72%, transparent);\n  color: #fff;\n  cursor: pointer;\n}\n\n.cdc__empty,\n.cdc__notice {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 400;\n  color: var(--cdc-muted);\n}\n\n.cdc__notice {\n  color: var(--cl-warn, #d97706);\n}\n\n/* Full-screen document camera (desktop / webcam). */\n.cdc-camera {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: grid;\n  grid-template-rows: 1fr auto;\n  background: #05070b;\n  color: #fff;\n  font-family: var(--cl-body, system-ui, sans-serif);\n}\n\n.cdc-camera__stage {\n  position: relative;\n  min-height: 0;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.cdc-camera__video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.cdc-camera__frame {\n  position: absolute;\n  inset: 8% 12%;\n  border: 2px solid color-mix(in srgb, #fff 70%, transparent);\n  border-radius: 14px;\n  box-shadow: 0 0 0 100vmax color-mix(in srgb, #000 35%, transparent);\n  pointer-events: none;\n}\n\n.cdc-camera__flash {\n  position: absolute;\n  inset: 0;\n  background: #fff;\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.cdc-camera__status {\n  position: absolute;\n  max-width: 26rem;\n  margin: 0;\n  padding: 0 1.5rem;\n  text-align: center;\n  font-size: 0.95rem;\n  color: color-mix(in srgb, #fff 80%, transparent);\n}\n\n.cdc-camera__status--error {\n  color: #fecaca;\n}\n\n.cdc-camera__bar {\n  display: grid;\n  gap: 0.75rem;\n  padding: 0.9rem 1.25rem calc(1.1rem + env(safe-area-inset-bottom, 0px));\n  background: #0b0f17;\n}\n\n.cdc-camera__hint {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  color: color-mix(in srgb, #fff 72%, transparent);\n}\n\n.cdc-camera__controls {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 1rem;\n}\n\n.cdc-camera__btn {\n  appearance: none;\n  justify-self: start;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 2.75rem;\n  padding: 0 1rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, #fff 25%, transparent);\n  background: transparent;\n  color: #fff;\n  font-family: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.cdc-camera__btn--done {\n  justify-self: end;\n  background: #fff;\n  color: #0b0f17;\n  border-color: #fff;\n}\n\n.cdc-camera__shutter {\n  appearance: none;\n  width: 4.4rem;\n  height: 4.4rem;\n  padding: 0.3rem;\n  border-radius: 999px;\n  border: 3px solid #fff;\n  background: transparent;\n  cursor: pointer;\n}\n\n.cdc-camera__shutter span {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: 999px;\n  background: #fff;\n  transition: transform 0.12s ease;\n}\n\n.cdc-camera__shutter:active:not(:disabled) span {\n  transform: scale(0.88);\n}\n\n.cdc-camera__shutter:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
